var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row justify-content-between"},[_c('div',{staticClass:"col-auto px-1"},[_c('SearchLegalEntity')],1)])]),_c('div',{staticClass:"card-body py-0 px-1"},[_c('TableLegalEntity')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }